import { render, staticRenderFns } from "./savings.vue?vue&type=template&id=91bcaa5e&"
import script from "./savings.vue?vue&type=script&lang=js&"
export * from "./savings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports